import { object, string } from 'yup';

export const nominationSchema = object().shape({
    nomineeId: string().uuid().required('This field is required'),
    nominationReason: string().required('This field is required').min(10, 'Minimum 10 characters required'),
});


